import { Stack, Typography } from '@mui/material'

/**
 * One titled section of the Thoughts panel.
 *
 * The caption is the framing, and it is not decoration: it is what tells a
 * reader whether they are looking at the agent's own account of its work or at
 * something the server confirmed. Without it the two sections look alike and a
 * model claim reads as a verified fact.
 */
export default function WorkSection({ title, caption, children }) {
  return (
    <Stack sx={{ gap: 0.75 }}>
      <Stack sx={{ gap: 0.1 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: 'var(--app-text-primary)' }}>
          {title}
        </Typography>
        {caption ? (
          <Typography sx={{ fontSize: 13, color: 'var(--app-text-tertiary)' }}>
            {caption}
          </Typography>
        ) : null}
      </Stack>
      {children}
    </Stack>
  )
}
